@if (visible) {
<div class="modal fade show d-block success-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow-lg rounded-4">
      <div class="modal-body p-4 text-center">
        <div class="status-icon mx-auto mb-3" [class.status-icon--info]="variant === 'info'">
          <i class="bi" [class.bi-check-lg]="variant === 'success'" [class.bi-info-lg]="variant === 'info'"></i>
        </div>

        <h4 class="fw-semibold mb-2">{{ title }}</h4>
        <p class="text-muted mb-4">{{ message }}</p>

        <button
          type="button"
          class="btn px-4"
          [class.btn-success]="variant === 'success'"
          [class.btn-info]="variant === 'info'"
          [class.text-white]="variant === 'info'"
          (click)="close()">
          Aceptar
        </button>
      </div>
    </div>
  </div>
</div>
}
